/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import { GiWolverineClaws } from 'react-icons/gi';
import { FaHippo, FaUsers } from 'react-icons/fa';
import { ImStatsDots } from 'react-icons/im';
import { MdOutlinePersonAdd, MdLogout } from 'react-icons/md';
import { TbMoodCry } from 'react-icons/tb';
import { CgNotes } from 'react-icons/cg';
import { FiPlusCircle } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../redux/slices/header-slice.js';
import useCurrentUser from '../hooks/useCurrentUser.js';
import useAuthentication from '../hooks/useAuthentication.js';

import LoadingSpinner from '../components/common/LoadingSpinner.jsx';
import NavTile from '../components/homepage/NavTile.jsx';
import {
    blue,
    darkRed,
    green,
    lightBlue,
    orange,
    pink,
    purple,
    red,
    yellow
} from '../styles/standard-colors.js';
import ErrorMessage from '../components/common/ErrorMessage.jsx';

/**
 * React component representing the homepage of the Oracle application.
 *
 * @component
 */
const Homepage = () => {
    const { loading, error, logout } = useAuthentication();
    const { canManageTeams } = useCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setActiveTab(null));
    });

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <div className="homepage-container">
            <h2>Welcome to Oracle!</h2>
            <div className="homepage-icons-container">
                <div className="homepage-icons-column">
                    <NavTile
                        title="Office Notes"
                        color={blue}
                        to="/notes"
                        id="homepage-notes"
                        icon={CgNotes}
                    />
                    <NavTile
                        title="New SC"
                        color={red}
                        to="/newsc"
                        id="homepage-newsc"
                        icon={MdOutlinePersonAdd}
                    />
                    <NavTile
                        title="Team Tasks"
                        color={purple}
                        to="/tasks"
                        id="homepage-tasks"
                        icon={CgNotes}
                    />
                    <NavTile
                        title="Admin"
                        color={green}
                        to="/admin"
                        id="homepage-admin"
                        icon={GiWolverineClaws}
                    />
                    <NavTile
                        title="HIPAA"
                        color={orange}
                        to="/hipaa"
                        id="homepage-hipaa"
                        icon={FaHippo}
                    />
                    <div onClick={logout}>
                        <NavTile
                            title="Logout"
                            color={darkRed}
                            id="homepage-logout"
                            icon={MdLogout}
                            onClick={logout}
                        />
                    </div>
                </div>
                <div className="homepage-icons-column">
                    <NavTile
                        title="Install Fails"
                        color={pink}
                        to="/installfails"
                        id="homepage-install"
                        icon={TbMoodCry}
                    />
                    {canManageTeams && (
                        <NavTile
                            title="Team Management"
                            color={purple}
                            to="/manage-users"
                            id="homepage-user"
                            icon={FaUsers}
                        />
                    )}
                    <NavTile
                        title="Reporting"
                        color={lightBlue}
                        to="/reporting"
                        id="homepage-reporting"
                        icon={ImStatsDots}
                    />
                    <NavTile
                        title="TSplus"
                        color={yellow}
                        to="/licenses"
                        id="homepage-tsplus-licenses"
                        icon={FiPlusCircle}
                    />
                </div>
            </div>
            <br />
            <br />
            {error && <ErrorMessage message={error.message} />}
        </div>
    );
};

export default Homepage;
